
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ModalBoxPhotoPreliminaryCheckContent extends Vue {
    @Prop() errorsCallback!: () => Array<string>
    @Prop() uploadCallback!: () => void

    errors (): Array<string> {
        return this.errorsCallback()
    }

    upload (): void {
        this.uploadCallback()
    }
}
